import React, {useEffect} from 'react'
import {Modal} from 'react-bootstrap'
import {KTIcon} from '../../../_metronic/helpers'
import {TransfertStatutVehiculeForm} from './components/TransfertStatutVehiculeForm'

const TransfertStatutVehiculeModal = ({
  show,
  vehiculeId,
  numeroVehicule,
  showModal,
  data,
  setData,
  marqueModele,
}) => {
  return (
    <>
      <Modal
        size='lg'
        tabIndex={-1}
        aria-hidden='true'
        dialogClassName='modal-dialog modal-dialog-centered'
        show={show}
      >
        <div className='modal-content'>
          <div className='modal-header'>
            <h5 className='modal-title'>
              Demande de transfert de statut pour le véhicule n° {numeroVehicule} {marqueModele}
            </h5>
            <div
              className='btn btn-icon btn-sm btn-light-primary ms-2'
              onClick={() => showModal(false)}
            >
              <KTIcon className='fs-2' iconName='cross' />
            </div>
          </div>
          <TransfertStatutVehiculeForm
            vehiculeId={vehiculeId}
            numeroVehicule={numeroVehicule}
            showModalProp={showModal}
            data={data}
            setData={setData}
          />
        </div>
      </Modal>
    </>
  )
}

export {TransfertStatutVehiculeModal}
